import get from 'lodash/get.js';

export const getPrivateOffer = transactionEdges => {
    const foundTransaction = (transactionEdges || []).find(
        transaction =>
            transaction &&
            transaction.node &&
            transaction.node.isPrivateOffer &&
            !transaction.node.isCanceled
    ) || { node: null };

    return get(foundTransaction, 'node');
};
